import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-ink-950 py-20" aria-labelledby="faq" data-id="element-73" data-mp="1bmln38v77zl0">
      <div className="mx-auto w-full max-w-3xl px-4 sm:px-6" data-id="element-74" data-mp="1gketa1wi4tla">
        <h2 id="faq" className="font-display text-3xl font-900 leading-tight text-white sm:text-4xl" data-id="element-75" data-mp="248o7oirdyf2e">
          Lo que más nos preguntan
        </h2>

        <ul className="mt-10 divide-y divide-ink-800 border-y border-ink-800" data-id="element-76" data-mp="289zygrlzx6c6">
          {faqs.map((faq, index) => {
          const isOpen = open === index;
          return <li key={faq.question} data-id="element-77" data-mp="1zhfwpiaeqln4" data-mpi={index}>
                <h3 data-id="element-78" data-mp="1zgd6zdotmp8s">
                  <button onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 py-5 text-left transition-colors duration-150 ease-smooth hover:text-gold" data-id="element-79" data-mp="2n8273g7vwi0a">
                    <span className="font-display text-base font-700 text-white sm:text-lg" data-id="element-80" data-mp="14vk1tldov482">
                      {faq.question}
                    </span>
                    <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full border border-ink-600 text-gold" data-id="element-81" data-mp="1eldc8j23hdaq">
                      {isOpen ? <MinusIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-82" data-mp="19sahi7lkzxsy" /> : <PlusIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-83" data-mp="1oi89yzqjn9ny" />}
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-84" data-mp="1jmj4ygvr90k9">
                  {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-85" data-mp="1xiodg97aegst">
                      <p className="pb-6 pr-10 text-[15px] leading-relaxed text-slate-300" data-id="element-86" data-mp="1ybfvaho9smhl">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}